import { NavLink } from 'react-router-dom';

import getImgUrl from "../helper/getImgUrl";
import styles from '../styles/landingproducts.module.css';
import CurrencyDisplay from "./CurrencyDisplay";

const LandingProducts = ({ product }) => {

    return (
        <div className={styles.card}>
            <div className={styles.imageWrapper}>
                <img src={getImgUrl(product.images[0], 'product')} alt={product.alt}/>
            </div>
            <div className={styles.info}>
                <h3>{product.title}</h3>
                <div className={styles.materialList}>
                    {product.materials.map((material, idx) => (
                        <span key={idx} className={styles.tag}>{material}</span>
                    ))}
                </div>
                <CurrencyDisplay amount={product.price} currency='CAD'/>
            </div>
            <NavLink to={`/productpage/${product.id}`} className={styles.viewLink}>
                <button className={styles.viewBtn}>View Product</button>
            </NavLink>
        </div>
    );
};

export default LandingProducts;
